'use client';

import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';



interface ItemsPaginationProps {
  count: number;
  page: number;
  onPageChnage : (pageNumber: number) => void;
}

export function ItemsPagination({ count, page,onPageChnage }: ItemsPaginationProps): React.JSX.Element {
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    onPageChnage(0);
  };
  const handleTaxLiablityChangePage = (event: unknown, newPage: number) => {
    onPageChnage(newPage);
  };
  return (
    <TablePagination
      component="div"
      count={count}
      onPageChange={handleTaxLiablityChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[5, 10, 25]}
    />
  );
}
